import { css } from '@emotion/core';
import { css as className } from 'emotion';
import styled from '@emotion/styled';

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 64px;
  @media (max-width: 600px) {
    margin-bottom: 36px;
    padding: 0 24px;
  }
`;

const Heading = styled.h2`
  margin: 0;
  font-weight: 800;
  font-size: 3.2rem;
  @media (max-width: 600px) {
    font-weight: bold;
    font-size: 2.4rem;
  }
`;

const SectionHeading = styled.h3`
  margin: 0 0 15px 0;
  padding: 0;
  font-weight: bold;
  font-size: 2rem;
  @media (max-width: 600px) {
    padding: 0 24px;
    font-size: 1.6rem;
  }
`;

const InlineLabelHeading = styled.h4`
  margin: 0;
  padding: 0;
  font-weight: normal;
  font-size: 1.6rem;
`;

const FieldSelectWrapper = styled.div`
  max-width: 450px;
  margin-bottom: 24px;
  @media (max-width: 600px) {
    max-width: unset;
    padding: 0 24px;
  }
`;

const Form = styled.form`
  width: 100%;
  max-width: 926px;
  margin: auto;
`;

const WhiteFormSection = styled.div`
  margin-bottom: 56px;
  padding: 40px;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  @media (max-width: 600px) {
    padding: 24px;
  }
`;

const FieldToggleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  @media (max-width: 600px) {
    padding: 0 24px;
  }
`;

const HorizontalRule = styled.hr`
  margin: 72px 0;
  border: 1px solid #dfe0e1;
  @media (max-width: 600px) {
    margin: 72px 24px;
  }
`;

const FieldWrapper = styled.div`
  margin-bottom: 20px;
`;

const ExplicitFieldWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 345px;
  margin-bottom: 36px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const explicitFieldClassName = className`
  flex: 1;
  margin-right: 30px;
  @media (max-width: 600px) {
    margin-right: unset;
    margin-bottom: 32px;
  }
`;

const VanitySlugAndColorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 690px;
  margin-bottom: 56px;
  @media (max-width: 600px) {
    flex-direction: column;
    padding: 0 24px;
  }
`;

const VanitySlugFieldContainer = styled.div`
  flex: 2;
  margin-right: 30px;
  @media (max-width: 600px) {
    margin: 0 0 32px;
  }
`;

const VanitySlugLabelHeadingCss = css`
  display: flex;
  align-items: center;
  height: 46px;
  margin: 0 12px 0 0;
`;

const profileHeaderColorFieldClassName = className`
  width: 100%;
  min-width: 167px;
  max-width: 210px;
  @media (max-width: 600px) {
    min-width: unset;
    max-width: unset;
  }
`;

const MobileSaveContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1;
  display: none;
  width: 100%;
  padding: 16px 16px 24px 16px;
  background-color: #fff;
  box-shadow: 0px -2px 6px #dedfe0;
  @media (max-width: 600px) {
    display: block;
  }
`;

const MobileSaveErrorText = styled.p`
  margin-bottom: 16px;
  text-align: center;
`;

const MobileSaveButtonCss = css`
  width: 100%;
  margin: auto;
  @media (max-width: 600px) {
    display: flex;
  }
`;

const FieldDescription = styled.p`
  margin-top: 4px;
  color: #7f8287;
  font-size: 12px;
  line-height: 18px;
`;

export {
  HeadingContainer,
  Heading,
  SectionHeading,
  InlineLabelHeading,
  FieldSelectWrapper,
  FieldDescription,
  Form,
  WhiteFormSection,
  FieldToggleContainer,
  HorizontalRule,
  FieldWrapper,
  ExplicitFieldWrapper,
  explicitFieldClassName,
  VanitySlugAndColorContainer,
  VanitySlugFieldContainer,
  VanitySlugLabelHeadingCss,
  profileHeaderColorFieldClassName,
  MobileSaveContainer,
  MobileSaveErrorText,
  MobileSaveButtonCss,
};
